import api from "./apiService";

export const getSurveyForMe = async (tab = "available") => {
    return api.get("/survey/survey-for-me", { params: { tab } });
};

export const getSurveyForMeDetails = async (data) => {
    return api.post("/survey/survey-for-me-details", data);
};

export const submitSurvey = async (data) => {
    return api.post("/survey/submit-survey", data);
};

export const getPreviewSubmittedSurvey = async (surveyId) => {
    return api.get(`/survey/preview-submitted-survey/${surveyId}`);
};

export const deleteSurveyResponse = async (responseId) => {
    return api.delete(`/survey/survey-response/${responseId}`);
};

export const saveSurvey = async (data) => {
    return api.post("/survey/save-survey", data);
};

export const completeSurvey = async (data) => {
    return api.post("/survey/complete-survey", data);
};

export const likeOnSurvey = async (data) => {
    return api.post("/survey/like-OnSurvey", data);
};

export const commentOnSurvey = async (data) => {
    return api.post("/survey/comment-OnSurvey", data);
};

export const likeOnComment = async (data) => {
    return api.post("/survey/like-OnComment", data);
};

export const getSurveyComments = async (surveyId) => {
    return api.get(`/survey/survey-comments/${surveyId}`);
};

export const fetchSurveyLikes = async (surveyId) => {
    return api.get(`/survey/fetch-survey-likes/${surveyId}`);
};

export const getCommentReplies = async (commentId) => {
    return api.get(`/survey/comment-replies/${commentId}`);
};

const surveyForMeService = {
    getSurveyForMe,
    getSurveyForMeDetails,
    submitSurvey,
    getPreviewSubmittedSurvey,
    deleteSurveyResponse,
    saveSurvey,
    completeSurvey,
    likeOnSurvey,
    commentOnSurvey,
    likeOnComment,
    getSurveyComments,
    fetchSurveyLikes,
    getCommentReplies,
};

export default surveyForMeService;
